export const montserrat = "'Montserrat', sans-serif;";
export const abrilFatface = "'Abril Fatface', cursive";
export const lato = "'Lato', sans-serif";
